module.exports = __webpack_public_path__ + "static/photo-sharing-social-media-app-plp-95b149c45523c7ee4e18ffda02401685.png";